<template>
  <div ref="container">
    <a-modal :title="title" :width="1200" :visible="visible" :maskStyle="{'top':'93px','left':'154px'}" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 80%;">
      <a-table :dataSource="dataSource" :loading="loading" :pagination="pagination" :columns="columns">
        <template slot="customRenderFlag" slot-scope="status">
          <a-tag v-if="status===0" color="green">启用</a-tag>
          <a-tag v-if="status===2" color="orange">禁用</a-tag>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { udiStockRecord } from '@/api/api'
export default {
  name: 'VendorModal',
  data() {
    return {
      title: '调整记录',
      visible: false,
      model: {},
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        onChange: this.handlePageChange,
      },
      dataSource: [],

      columns: [
        {
          title: '调整前数量',
          dataIndex: 'preNumber',
        },
        {
          title: '调整后数量',
          dataIndex: 'currentNumber',
        },
        {
          title: '操作人员',
          dataIndex: 'createBy',
        },
        {
          title: '操作时间',
          dataIndex: 'createTime',
        },
        {
          title: '备注',
          dataIndex: 'remark',
        },
        // {
        //   title: '电话号码',
        //   dataIndex: 'phonenum',
        // },
        // {
        //   title: '排序',
        //   dataIndex: 'userBlngOrgaDsplSeq',
        // },
        // {
        //   title: '状态',
        //   dataIndex: 'status',
        //   width: 60,
        //   align: 'center',
        //   scopedSlots: { customRender: 'customRenderFlag' },
        // },
      ],
    }
  },
  created() {},
  methods: {
    async add(e) {
      console.log(e, 'e1')
      this.visible = true
      this.pagination.current = 1

      this.loading = true

      const res = await udiStockRecord({ stockId: e.uuid })
      console.log(res, 'res123___')
      if (res.code == 200 && res.data) {
        this.dataSource = res.data
        this.loading = false
      } else {
        this.$message.error(res.data)
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      // 触发表单验证
      this.handleCancel()
    },
    handleCancel() {
      this.close()
    },
    handlePageChange(page, pageSize) {
      console.log(page, 'page')
      console.log(pageSize, 'pageSize')
      this.pagination.current = page
    },
  },
}
</script>
<style scoped>
</style>